module.exports = __webpack_public_path__ + "b2c1533bd42fe898179ea2fe808bda1f.woff2";